module.exports = __webpack_public_path__ + "img/project_spectrum.d0d277be.png";